export default "__VITE_ASSET__4fb4e605__"